<template>
    <el-drawer
         :title="status == 0 ? '推送审核' : '推送详情'"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="800px"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading" v-if="data">
            <div class="group">
                <div class="page-group-title"><span>推送人信息</span></div>
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col :xs="24" :sm="12"><span class="color-info">推送人ID: </span>{{data.pushUserId}}</el-col>
                        <el-col :xs="24" :sm="12"><span class="color-info">推送名称: </span>{{data.pushUserName}}</el-col>
						<el-col :xs="24" :sm="12"><span class="color-info">推送身份: </span>
							<span v-if="data.userType == 1">乐迷</span>
							<span v-if="data.userType == 2">艺人</span>
							<span v-if="data.userType == 3">场地</span>
							<span v-if="data.userType == 5">厂牌</span>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8"><span class="color-info">关联业务: </span>{{data.business}}</el-col>
                    </el-row>
                 </el-card>
            </div>
			<div class="group">
			    <div class="page-group-title"><span>推送信息</span></div>
			    <el-card shadow="never" class="MT20">
			        <el-row :gutter="40">
			            <el-col :xs="24"><span class="color-info">标题: </span>{{data.title}}</el-col>
			            <el-col :xs="24"><span class="color-info">内容: </span>{{data.content}}</el-col>
			        </el-row>
			     </el-card>
			</div>
			<div class="group" v-if="status == 0">
			    <div class="page-group-title"><span>审核备注</span><span class="color-danger smallSize">(请在审核备注填写拒绝通过的理由。拒绝后，B类用户会收到短信通知)</span></div>
			    <el-input v-model.trim="reason" type="textarea" :rows="2" maxlength="100" show-word-limit ></el-input>
			</div>
        </div>
        <div class="drawer-footer"  v-if="data">
            <el-button @click="close">关闭</el-button>
            <el-button type="primary" :loading="btnLoading" @click="pass()"  v-if="status == 0">通过</el-button>
			<el-button type="danger"  :loading="btnLoad2ing" @click="refuse()"  v-if="status == 0">拒绝</el-button>
        </div>
    </el-drawer>
</template>
<script>

export default {
    data(){
        return{
            drawerShow:false,
            btnLoading:false,
			btnLoad2ing:false,
            dataLoading:false,            
            id:"",
			status:"",
			data:null,
			reason:''
        }
    },
    methods:{
        show(id,status){
            this.id = id || '';
			this.status = status ||'';
            if( this.id ){
                this.getDataDetails();
            }
            this.drawerShow = true;
        },
        close(){
           
            this.reason = ''
            this.drawerShow = false;
        },
        //获取详情
        getDataDetails(){
            this.dataLoading = true;
            this.$request({
                url: '/push/manage/detail',
                params: {id: this.id},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = result
                    } else {
                        this.$message.error(msg || "获取详情失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取详情失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
		pass(){
			this.$confirm('通过后，会立即发送推送，是否确认通过？', '提示', {
			type: 'warning',
			center: true,
			closeOnClickModal: false
			}).then(() => {
				this.btnLoading = true;
				this.$request({
					url: '/push/manage/audit',
					params: {id: this.id,type:1},
					method: "post",
				})
					.then((res) => {
						const { state, msg } = res.data;
						if (state == 1) {
							this.$emit('onUpdate');
							this.close()
						} else {
							this.$message.error(msg || "操作失败,请重试");
						}
					})
					.catch(() => {
						this.$message.error("操作失败,请重试");
					})
					.finally(() => {
						this.btnLoading = false;
					});
			}).catch(() => {})
		},
		refuse(){
			if( this.reason == ''){
				this.$message.error('请先填写拒绝原因');
				return
			}
			this.$confirm('拒绝后，B类用户会收到短信通知，确认拒绝？', '提示', {
			type: 'warning',
			center: true,
			closeOnClickModal: false
			}).then(() => {
				this.btnLoad2ing = true;
				this.$request({
					url: '/push/manage/audit',
					params: {id: this.id,type:2,reason:this.reason},
					method: "post",
				})
					.then((res) => {
						const { state, msg } = res.data;
						if (state == 1) {
							this.$emit('onUpdate');
							this.close()
						} else {
							this.$message.error(msg || "操作失败,请重试");
						}
					})
					.catch(() => {
						this.$message.error("操作失败,请重试");
					})
					.finally(() => {
						this.btnLoad2ing = false;
					});
			}).catch(() => {})
		}        
    }
}
</script>
<style lang="scss" scoped>
.el-card{
    .el-col{
        line-height: 28px;
    }
}
.smallSize{
	font-size: 12px;
}
</style>